import { FC } from 'react';

import checkmarkIcon from 'shared/components/SuperhostPage/assets/checkmark.svg';

import style from './StickerRules.css';

const RULES = [
  {
    key: 'status',
    title: 'Вы можете получить наклейку только при наличии статуса Суперхозяин в личном кабинете',
  },
  {
    key: 'limit',
    title: 'Максимальное количество наклеек для одного аккаунта – 5 штук',
    description:
      'Если опубликованных объектов меньше, то пришлём в соответствии с их числом. Если объектов больше, рекомендуем разместить наклейки только на самых популярных объектах',
  },
  {
    key: 'once',
    title: 'В течение календарного года можете оставить только одну заявку',
  },
  {
    key: 'delivery',
    title: 'Доставка осуществляется простым письмом Почты России – убедитесь в корректности адреса',
  },
];

export const StickerRules: FC = () => {
  return (
    <section className={style['section']}>
      <div className={style['inner']}>
        <div className={style['sidebar']}>
          <h2 className={style['title']}>Ваша заявка на наклейку</h2>
          <p className={style['subtitle']}>Обратите внимание на правила отправки наклеек</p>
        </div>
        <div className={style['list']}>
          {RULES.map(rule => (
            <div key={rule.key} className={rule.description ? style['item--top'] : style['item']}>
              <img alt="" className={style['checkmark']} src={checkmarkIcon} />
              <div className={style['item-content']}>
                <p className={style['item-title']}>{rule.title}</p>
                {rule.description && <p className={style['item-description']}>{rule.description}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
